export default __webpack_public_path__ + "static/media/dermatology.8d746075.jpg";